export const COMMON = Object.freeze(['amd64', 'arm64', 'i386', 'arm']);
export const UNCOMMON = Object.freeze(['unknown', 'ppc64le', 'ppc64', 'mips64le', 'mips64', 'mipsle', 'mips', 's390x'].sort());